<jw-modal id="documentUploadModal">
  <h5>Upload</h5>

  <app-uploader [entityId]='this.vehicleId' type='vehicle'></app-uploader>

  <button class='btn btn-primary' (click)='this.close()'>Close</button>
</jw-modal>
